/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Filter_Last_MonthsInputs */

const en_ui_filter_last_months = /** @type {(inputs: Ui_Filter_Last_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last ${i?.count} months`)
};

const de_ui_filter_last_months = /** @type {(inputs: Ui_Filter_Last_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`letzte ${i?.count} Monate`)
};

/**
* | output |
* | --- |
* | "last {count} months" |
*
* @param {Ui_Filter_Last_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_months = /** @type {((inputs: Ui_Filter_Last_MonthsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_MonthsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_months(inputs)
	return de_ui_filter_last_months(inputs)
});